/**
 * Country-based Custom Data Handler
 *
 * This script automatically populates elements with .custom_data class
 * based on the user's localization.country setting.
 */

(function() {
  'use strict';

  // Hardcoded JSON data structure
  // Format: { countryCode: { key: value } }
  const COUNTRY_DATA = {
    // 24-72 hours - Portugal, Spain
    'PT': {
      'shipping': 'Free shipping',
      'delivery': '24-72 hours',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'ES': {
      'shipping': 'Free shipping',
      'delivery': '24-72 hours',
      'currency': 'EUR',
      'phone': '+34 91 123 4567',
      'support_hours': '9:00 - 17:00 CET'
    },
    // 3-4 days - Austria
    'AT': {
      'shipping': 'Free shipping',
      'delivery': '3-4 days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    // 3-5 days - Czechia
    'CZ': {
      'shipping': 'Free shipping',
      'delivery': '3-5 days',
      'currency': 'CZK',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    // 3-6 days - Poland, Romania
    'PL': {
      'shipping': 'Free shipping',
      'delivery': '3-6 days',
      'currency': 'PLN',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'RO': {
      'shipping': 'Free shipping',
      'delivery': '3-6 days',
      'currency': 'RON',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 EET'
    },
    // 4-10 days - Denmark, Estonia, Norway, Sweden
    'DK': {
      'shipping': 'Free shipping',
      'delivery': '4-10 days',
      'currency': 'DKK',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'EE': {
      'shipping': 'Free shipping',
      'delivery': '4-10 days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 EET'
    },
    'NO': {
      'shipping': 'Free shipping',
      'delivery': '4-10 days',
      'currency': 'NOK',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'SE': {
      'shipping': 'Free shipping',
      'delivery': '4-10 days',
      'currency': 'SEK',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    // 4-7 business days - Greece, Slovakia, Switzerland
    'GR': {
      'shipping': 'Free shipping',
      'delivery': '4-7 business days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 EET'
    },
    'SK': {
      'shipping': 'Free shipping',
      'delivery': '4-7 business days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'CH': {
      'shipping': 'Free shipping',
      'delivery': '4-7 business days',
      'currency': 'CHF',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    // 4-7 days - Croatia, Hungary, Latvia, Lithuania
    'HR': {
      'shipping': 'Free shipping',
      'delivery': '4-7 days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'HU': {
      'shipping': 'Free shipping',
      'delivery': '4-7 days',
      'currency': 'HUF',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'LV': {
      'shipping': 'Free shipping',
      'delivery': '4-7 days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 EET'
    },
    'LT': {
      'shipping': 'Free shipping',
      'delivery': '4-7 days',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 EET'
    },
    // 48-96 hours - Belgium, France, Germany, Italy, Netherlands
    'BE': {
      'shipping': 'Free shipping',
      'delivery': '48-96 hours',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    'FR': {
      'shipping': 'Free shipping',
      'delivery': '48-96 hours',
      'currency': 'EUR',
      'phone': '+33 1 23 45 67 89',
      'support_hours': '9h - 17h CET'
    },
    'DE': {
      'shipping': 'Free shipping',
      'delivery': '48-96 hours',
      'currency': 'EUR',
      'phone': '+49 30 12345678',
      'support_hours': '9:00 - 17:00 MEZ'
    },
    'IT': {
      'shipping': 'Free shipping',
      'delivery': '48-96 hours',
      'currency': 'EUR',
      'phone': '+39 02 1234 5678',
      'support_hours': '9:00 - 17:00 CET'
    },
    'NL': {
      'shipping': 'Free shipping',
      'delivery': '48-96 hours',
      'currency': 'EUR',
      'phone': 'Contact us',
      'support_hours': '9:00 - 17:00 CET'
    },
    // Other countries
    'US': {
      'shipping': 'Free shipping on orders over $50',
      'delivery': '2-5 business days',
      'currency': 'USD',
      'phone': '+1 (555) 123-4567',
      'support_hours': '9 AM - 5 PM EST'
    },
    'GB': {
      'shipping': 'Free shipping on orders over £40',
      'delivery': '3-7 business days',
      'currency': 'GBP',
      'phone': '+44 20 1234 5678',
      'support_hours': '9 AM - 5 PM GMT'
    },
    'CA': {
      'shipping': 'Free shipping on orders over $60 CAD',
      'delivery': '3-7 business days',
      'currency': 'CAD',
      'phone': '+1 (555) 234-5678',
      'support_hours': '9 AM - 5 PM EST'
    },
    'AU': {
      'shipping': 'Free shipping on orders over $75 AUD',
      'delivery': '5-10 business days',
      'currency': 'AUD',
      'phone': '+61 2 1234 5678',
      'support_hours': '9 AM - 5 PM AEST'
    },
    // Default fallback
    'DEFAULT': {
      'shipping': 'Free shipping on qualifying orders',
      'delivery': '5-10 business days',
      'currency': 'USD',
      'phone': 'Contact us',
      'support_hours': 'Business hours'
    }
  };

  /**
   * Get current country from Shopify localization
   * @returns {string} Country code (e.g., 'US', 'GB')
   */
  function getCurrentCountry() {
    // Try to get from Shopify localization object
    if (window.Shopify && window.Shopify.country) {
      return window.Shopify.country;
    }

    // Try to get from localization routes if available
    if (window.localization && window.localization.country) {
      return window.localization.country.iso_code;
    }

    // Fallback: try to parse from URL or routes
    const pathParts = window.location.pathname.split('/');
    if (pathParts.length > 1 && pathParts[1].length === 2) {
      return pathParts[1].toUpperCase();
    }

    // Default to US if nothing else works
    return 'DEFAULT';
  }

  /**
   * Get data for a specific key and country
   * @param {string} key - The data key to retrieve
   * @param {string} country - Country code
   * @returns {string} The data value or empty string
   */
  function getCountryData(key, country) {
    const countryData = COUNTRY_DATA[country] || COUNTRY_DATA['DEFAULT'];
    return countryData[key] || '';
  }

  /**
   * Replace placeholders in text content
   * Supports format: [[key_name]] or [[key_name|fallback value]]
   * @param {string} text - Text that may contain placeholders
   * @param {string} country - Country code
   * @returns {string} Text with placeholders replaced
   */
  function replacePlaceholders(text, country) {
    if (!text) return text;

    // Match [[key_name]] or [[key_name|fallback]] pattern
    const placeholderRegex = /\[\[([^\]|]+)(?:\|([^\]]+))?\]\]/g;

    return text.replace(placeholderRegex, (match, key, fallback) => {
      const data = getCountryData(key.trim(), country);

      // Return data if found, otherwise fallback, otherwise original match
      if (data) {
        return data;
      } else if (fallback) {
        return fallback.trim();
      } else {
        return match;
      }
    });
  }

  /**
   * Update all elements with .custom_data class
   */
  function updateCustomDataElements() {
    const currentCountry = getCurrentCountry();
    const elements = document.querySelectorAll('.custom_data');

    elements.forEach(element => {
      // Get the data key from data-key attribute
      const dataKey = element.dataset.key;

      if (!dataKey) {
        console.warn('Element with .custom_data has no data-key attribute:', element);
        return;
      }

      // Get the data for this key and country
      const data = getCountryData(dataKey, currentCountry);

      // Update the element's content
      if (data) {
        // Check if element has data-target attribute for specific child element
        const target = element.dataset.target;
        if (target) {
          const targetElement = element.querySelector(target);
          if (targetElement) {
            targetElement.textContent = data;
          } else {
            element.textContent = data;
          }
        } else {
          element.textContent = data;
        }
      }
    });

    console.log(`[Country Custom Data] Updated ${elements.length} .custom_data element(s) for country: ${currentCountry}`);
  }

  /**
   * Process all text nodes that may contain [[key]] placeholders
   */
  function processPlaceholders() {
    const currentCountry = getCurrentCountry();

    // Find all text nodes containing [[ ]]
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          // Only process text nodes that contain [[
          if (node.nodeValue && node.nodeValue.includes('[[')) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_SKIP;
        }
      }
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }

    // Replace placeholders in each text node
    textNodes.forEach(node => {
      node.nodeValue = replacePlaceholders(node.nodeValue, currentCountry);
    });

    console.log(`[Country Custom Data] Processed ${textNodes.length} placeholder(s) for country: ${currentCountry}`);
  }

  /**
   * Initialize the custom data handler
   */
  function init() {
    // Update on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        updateCustomDataElements();
        processPlaceholders();
      });
    } else {
      updateCustomDataElements();
      processPlaceholders();
    }

    // Also listen for Shopify section rendering events
    document.addEventListener('shopify:section:load', function() {
      updateCustomDataElements();
      processPlaceholders();
    });
    document.addEventListener('shopify:section:reorder', function() {
      updateCustomDataElements();
      processPlaceholders();
    });
  }

  // Start the script
  init();

  // Expose update function globally for manual triggers if needed
  window.updateCountryCustomData = function() {
    updateCustomDataElements();
    processPlaceholders();
  };

})();
